var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.5699 2.5378c-.2151-.8602-.914-1.5591-1.7742-1.7742C16.2366.3335 10 .3335 10 .3335s-6.2366 0-7.7957.4301C1.344.9786.6452 1.6776.43 2.5378 0 4.0969 0 7.3228 0 7.3228s0 3.2258.4301 4.7849c.215.8602.914 1.5591 1.7742 1.7742C3.7634 14.312 10 14.312 10 14.312s6.2366 0 7.7957-.4301c.8602-.2151 1.5591-.914 1.7742-1.7742C20 10.5486 20 7.3227 20 7.3227s-.0538-3.2795-.4301-4.7849zm-11.613 7.7957V4.312l5.1614 3.0107-5.1613 3.0108z"}));
}

Youtube.defaultProps = {"fill":"none","viewBox":"0 0 20 15"};

module.exports = Youtube;

Youtube.default = Youtube;
